<template>
  <div class="subheader-date">
    <div style="display: flex; flex-direction: column;">
      <div style="position: relative; min-width: 120px; width: 100%; display: flex; justify-content: flex-end;">
        <select
          id="farm-select"
          v-model="selectedFarmNm"
          v-if="farmNm !== '' && farmNm !== undefined && farmNm !== null"
          class="text font-weight-bold cursor-pointer"
          style="font-size: 1.5rem; text-align: start; min-width: 120px; max-width: 220px; width: auto; appearance: none; background: #fff; overflow: hidden; padding-right: 2.2em; text-overflow: ellipsis; white-space: nowrap;"
          @change="changeFarm()"
        >
          <option v-for="farm in farms" :key="farm.farmNm" :value="farm.farmNm">
            {{ farm.farmNm }}
          </option>
        </select>
        <span v-if="farmNm !== '' && farmNm !== undefined && farmNm !== null" style="position: absolute; right: 0.8em; top: 50%; transform: translateY(-50%); pointer-events: none; font-size: 1.5rem; color: #242424;">▼</span>
      </div>
      <span class="text font-weight-bold" style="text-align: start;">{{ dateStr }}</span>
    </div>
  </div>
</template>

<script>
import { todayToDate, getItems } from '@/core/services/funcs';
import { ACT_GET_MY_FARMS } from '@/core/services/variable';

export default {
  props: {
    farmNm: String
  },
  name: "Layout",
  data() {
    return {
      dateInterval: null,
      dateStr: '',
      farms: [],
      selectedFarmNm: this.farmNm
    }
  },
  watch: {
    farmNm(newVal) {
      this.selectedFarmNm = newVal;
    },
    selectedFarmNm(newVal) {
      this.$emit('update:farmNm', newVal); // 필요시 부모에 알림
    },
  },
  mounted() {
    this.clearDateInterval()
    this.dateStr = todayToDate()
    this.dateInterval = setInterval(() => {
      this.dateStr = todayToDate()
    }, 1000)
    this.getMyFarm();
  },
  destroyed() {
    this.clearDateInterval()
  },
  methods: {
    clearDateInterval() {
      if (this.dateInterval) {
        clearInterval(this.dateInterval);
        this.dateInterval = null
      }
      this.dateStr = ''
    },
    getMyFarm() {
      this.$store.dispatch(ACT_GET_MY_FARMS).then(resp => {
        const items = getItems(resp);
        this.farms = items;
        // farmNm과 일치하는 항목을 선택
        if (items && items.length > 0) {
          const found = items.find(f => f.farmNm === this.farmNm);
          this.selectedFarmNm = found ? found.farmNm : items[0].farmNm;
        }
      })
      .catch(e => {
        console.error(e);
      });
    },
    changeFarm() {
      const farmObj = this.farms.find(f => f.farmNm === this.selectedFarmNm);
      if (farmObj && farmObj.farmId) {
        // 현재 경로에서 farmId만 교체
        const currentPath = this.$route.path;
        const newPath = currentPath.replace(/(\/smartfarm\/)[^/]+/, `/smartfarm/${farmObj.farmId}`);

        // window.location.assign(newPath) // 강제 새로고침

        // ✅ 1. SPA 라우터 이동 (웹/앱 공통 안전)
        this.$router.push(newPath).then(() => {

          // ✅ 2. 강제 새로고침 (웹 + Cordova 둘 다 안전)
          setTimeout(() => {
            window.location.reload();
          }, 50);

        });

      } else {
        alert('farmId가 없습니다!');
      }
    }
  }
};
</script>